import React from 'react';
var PdpSubmissionItem = function (_a) {
    var data = _a.data, launchCarousel = _a.launchCarousel, activeIndex = _a.activeIndex;
    var attributeLink;
    var leader = (React.createElement("div", { className: "submission_image" },
        React.createElement("a", { href: data.url, rel: "nofollow", className: "plant_image_link", onClick: function (e) { return launchCarousel(e, activeIndex); } },
            React.createElement("div", { className: "image_container" },
                React.createElement("picture", null,
                    React.createElement("source", { type: "image/webp", srcSet: data.photo_webp }),
                    React.createElement("source", { type: "image/jpeg", srcSet: data.photo }),
                    React.createElement("img", { loading: "lazy", src: data.photo, alt: data.alt, width: data.w, height: data.h }))),
            React.createElement("div", { className: "plant__photo_hover" },
                React.createElement("span", null, "View Full Size")))));
    var attributeTxt = 'By: ';
    if (data.contributor_info.is_nursery && data.contributor_info.active) {
        attributeLink = "/nurseries/".concat(encodeURIComponent(data.contributor_info.slug), "/");
    }
    function formatPhoto() {
        if (data.source_url) {
            return (React.createElement("a", { href: data.source_url, target: "_blank", rel: "noopener nofollow", className: "carousal_link_source no_border" }, "View Original Photo"));
        }
        return null;
    }
    var avatar;
    var titleElement;
    var imgSrc = "".concat(process.env.STATIC_PATH, "/img/icn_pdp_description.svg");
    if (data.contributor_info.avatar) {
        imgSrc = data.contributor_info.avatar;
    }
    if (attributeLink) {
        avatar = (React.createElement("a", { href: attributeLink },
            React.createElement("img", { id: "avatar", src: imgSrc, alt: "" })));
        titleElement = (React.createElement("span", { className: "attr_title display_inline" },
            React.createElement("a", { href: attributeLink }, data.contributor_info.name ? data.contributor_info.name : 'Unknown')));
    }
    else {
        avatar = React.createElement("img", { id: "avatar", src: imgSrc, alt: "" });
        titleElement = React.createElement("span", { className: "attr_title display_inline" }, data.contributor_info.name ? data.contributor_info.name : 'Unknown');
    }
    return (React.createElement("div", { className: "submission_node" },
        React.createElement("div", { className: "submission_pres" },
            leader,
            React.createElement("div", { className: "submission_text no_min_height" },
                avatar,
                React.createElement("p", null,
                    React.createElement("span", { className: "attr display_inline" }, attributeTxt),
                    titleElement),
                data.copyright_info && (React.createElement("p", { className: "small" }, data.copyright_info)),
                formatPhoto()))));
};
export default PdpSubmissionItem;
